import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { PeptigenLogo } from "../components/Logo";
import { ShieldCheck, KeyRound } from "lucide-react";

export default function AdminLogin() {
  const { login, admin } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  React.useEffect(() => {
    if (admin) navigate("/admin");
  }, [admin, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(username, password);
      navigate("/admin");
    } catch (e) {
      const detail = e.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 relative overflow-hidden" style={{ backgroundColor: "#0B1220" }} data-testid="admin-login-page">
      <div className="absolute inset-0 pg-grid-bg opacity-50" />
      <div className="absolute inset-0 pg-radial-cyan" />
      <div className="relative z-10 w-full max-w-md">
        <div className="flex justify-center mb-8">
          <PeptigenLogo size={48} />
        </div>
        <div className="pg-card p-8">
          <div className="flex items-center gap-2 mb-2">
            <ShieldCheck size={18} className="text-[#A6FF00]" />
            <span className="pg-mono text-[10px] uppercase tracking-[0.22em] text-[#A6FF00]">
              Lab Access · Staff Only
            </span>
          </div>
          <h1 className="text-[#F7FAFC] text-2xl pg-heading mb-1" style={{ fontFamily: "'Rajdhani'" }}>
            Sign in to Peptigen Labs Admin
          </h1>
          <p className="text-[#9CA8B8] text-sm mb-6">
            Authorised personnel only. All access is logged.
          </p>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <div className="pg-micro mb-2">Username</div>
              <input
                required
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="pg-input"
                placeholder="David"
                data-testid="login-username"
              />
            </div>
            <div>
              <div className="pg-micro mb-2">Password</div>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="pg-input"
                data-testid="login-password"
              />
            </div>
            {error && (
              <div className="text-sm text-red-400 border border-red-400/40 bg-red-400/10 p-3 rounded-sm" data-testid="login-error">
                {error}
              </div>
            )}
            <button type="submit" disabled={submitting} className="pg-btn-primary w-full" data-testid="login-submit">
              <KeyRound size={16} /> {submitting ? "Signing in..." : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
